import Vue from 'vue'
import {RUN_KRA_USER_KYC,RUN_SAVE_USERNAME_COMIG_FROM_PAN_API,RUN_STEP_SKIP_API,RUN_ADMIN_ACCESS_USER_OTP,RUN_ADMIN_LOGIN,RUN_PAN_VERIFY,RUN_GET_INFORMATION_FROM_DIGILOCKER ,RUN_ADD_REGISTER_DATA_STEP_UPLOAD_DOCS,RUN_REGISTER_INITIAL_STEP1,RUN_REGISTER_INITIAL_STEP2, RUN_ADD_REGISTER_STEP5, RUN_GET_REGISTER_STEP5,RUN_GET_INFORMATION , RUN_ADD_REGISTER_DATA_STEP0 , RUN_ADD_REGISTER_DATA_STEP1 , RUN_ADD_REGISTER_DATA_STEP1_5 , RUN_ADD_REGISTER_DATA_STEP2,RUN_ADD_REGISTER_DATA_STEP3,RUN_ADD_REGISTER_DATA_STEP4, RUN_CREATE_LEAD, RUN_VERIFY_LEAD_OTP,RUN_VERIFY_DOB,RUN_USER_LOGIN,RUN_QUICKO,RUN_USER_LOGOUT,RUN_STATE_LOAD,GET_TOKEN,SET_STATE,SET_STATE_PERSIST_LOCAL,SET_TOGGLE_LOADER,SET_INFO,GET_USER, RUN_GET_QUESTION_ANSWER, RUN_VERIFY_OTP, RUN_VERIFY_QUEST_ANS, RUN_CHANGE_PASSWORD_FORGOT, RUN_CHANGE_FORGOT_PASSWORD, RUN_UNBLOCK_USER_HASH, RUN_BLOCK_USER, RUN_UNBLOCK_USER, SET_QUESTIONS, RUN_SAVE_USER_QUESTION_ANS, RUN_CHANGE_PASSWORD,RUN_DELETE_DOCUMENT,RUN_USER_VPA,RUN_GET_DIGILOCKER_URL,RUN_USER_LOGIN_WITH_OTP,RUN_USER_VERIFY_OTP,RUN_NO_ADD_NOMINEE, RUN_ADD_STEP_AFTER_UPLOAD_PROFILE_IMAGE,RUN_CHECK_BANK_LIST_AGGREGATOR,SET_BANK_AGGREGATOR_LIST, SET_API_DISCLAIMER, RUN_WEB_ENGAGE_USER, RUN_HDFC_TRANSACTIONS, RUN_HDFC_VALIDATE_TRANSACTION,RUN_GET_DIGILOCKER_KYC_DATA,FETCH_DIGIO_ESIGN_ID, RUN_SUBMIT_DIGIO_ESIGN_DOCUMENT} from '../types'
import * as RxFactory from './api/rx-factory'
import * as types from '@/types'
import { Const } from '../plugins/prism/provider/candle-history/lib/const.cls'
import CryptoJS from 'crypto-js';

export const EP_ADD_STEP_AFTER_UPLOAD_PROFILE_IMAGE			= 				'/add/step/after/upload/profile/image'
export const EP_ADMIN_LOGIN 			= 				'/admin/user/access'
export const EP_USER_LOGIN 			    = 				'/api/login'
export const EP_QUICKO_LINK 			    = 			'/api/quicko/login'
export const EP_ADMIN_LOGOUT 			= 				'/signout'
export const EP_CHECK_BANK_LIST_AGGREGATOR 			= 	process.env.LOCAL_AA_SERVER_FULL_ADDRESS + '/account-aggregator/api/get-fip?category=Bank'
export const EP_CREATE_LEAD 			= 				'/api/create/lead'
export const EP_VERIFY_OTP_LEAD 		= 				'/api/verify/otp/lead'
export const EP_VERIFY_DOB 				= 				'/api/verify/kra'
export const EP_VERIFY_PAN				= 				'/api/verify/pan'
export const EP_WEB_ENGAGE_USER         =               '/api/verify/webengage/user'

export const EP_USER_LOGIN_WITH_OTP		= 				'/api/otp/login'

export const EP_USER_VERIFY_OTP			= 				'/api/verify/otp/login'

export const EP_RUN_GET_INFORMATION     = 				'/get/step/information'

export const EP_ADD_REGISTER_DATA_STEP0 = 				'/api/add/bankaccount'
export const EP_ADD_REGISTER_DATA_STEP  = 				'/add/step/information'
export const EP_ADD_COMPLAINT_DATA 		= 				'/api/add/nominee'
export const EP_NO_ADD_NOMINEE 			= 				'/api/no/nominee'
export const EP_ADD_REGISTER_DATA_STEP4	=				'/upload/user/docs'
export const EP_GET_REGISTER_DATA_STEP5 = 				'/api/get/profile'
export const EP_VERIFY_OTP_IPV        	=      			'/verify/otp/ipv'
export const EP_UPLOAD_IPV_IMAGE       	=      			'/upload/ipv/image'
export const EP_GET_INFORMATION_FROM_DIGILOCKER  = 		'/get/digilocker/data'
export const BASE_URL 					= 				 process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS

export const EP_RUN_GET_QUESTION 			= '/user/get/questions'
export const EP_RUN_SAVE_USER_QUESTION 		= '/user/save/answers'
export const EP_RUN_CHANGE_PASSWORD 		= '/change/password'
export const EP_RUN_BLOCK_USER 				= '/block/user'
export const EP_RUN_UNBLOCK_USER 			= '/unblock/user'
export const EP_RUN_VERIFY_USER_QUESTION 	= '/user/verify/answers'
export const EP_KRA_USER_KYC_NON_KRA		=	'/nonkra/approve/user'
export const EP_RUN_CHANGE_PASSWORD_FORGOT 	= '/change/via/forgot/password'

export const EP_RUN_SEND_FORGOT_PASSWORD_EMAIL 	= '/forgot/password'
export const EP_RUN_UNBLOCK_HASH 				= '/send/unblock/hash'
export const EP_STEP_SKIP_API 				= '/user/skip/documentation'
export const EP_KRA_USER_KYC				= '/admin/approve/user'
export const EP_DELETE_DOCUMENT				= '/api/delete/docs'
export const EP_GET_DIGILOCKER_URL			=	'/api/digilocker/auth'
export const EP_RUN_GET_DIGILOCKER_KYC_DATA =  '/api/get/digio-document-data';
export const EP_SAVE_USERNAME_COMIG_FROM_PAN_API		=	 '/api/pancard/service'
export const EP_SET_API_DISCLAIMER 			= 			'/update/disclaimer'
export const EP_HDFC_TRANSACTIONS = '/api/hdfc/transaction-list';
export const EP_HDFC_VALIDATE_TRANSACTION = '/api/hdfc/validate-transaction';

export const EP_FETCH_DIGIO_ESIGN_ID		= '/api/digio/esign-requests'
export const EP_RUN_SUBMIT_ESIGN_DOCUMENT	= '/api/digio/esign-webhook'

const Swal = require('sweetalert2')
const msz_display_time = 10000

export const actions = {  
	[RUN_GET_DIGILOCKER_URL]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.rout
		delete credentials.rout
		_executeApi(EP_GET_DIGILOCKER_URL,parameter,credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				window.open(result.res_data.auth_url, "myWindow", "width=500,height=500,top=50%,left=500");
				//window.open(, '_blank');
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
	  [RUN_GET_DIGILOCKER_KYC_DATA]({commit, state, dispatch,getters}, credentials){
		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.rout
		delete credentials.rout
		_executeApi(EP_RUN_GET_DIGILOCKER_KYC_DATA,parameter,credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				localStorage.setItem("digiLockerAttempt1", 'success');
				parameter.refreshData()
				parameter.digilocker_info = true
			}else{
				localStorage.setItem("digiLockerAttempt1", 'fail');
				parameter.div_hide_show = 1
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
	},
	[RUN_ADMIN_LOGIN]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.router
		delete credentials.router
		_executeApi(EP_ADMIN_LOGIN,parameter,credentials,'',commit, (error, result)=>{
			if(!error){
				parameter.modal = 2
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	[RUN_ADMIN_ACCESS_USER_OTP]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.router
		delete credentials.router
		_executeApi(EP_USER_LOGIN,parameter,credentials,'',commit, (error, result)=>{
			if(!error){
				
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
	[RUN_QUICKO]({commit, state, dispatch,getters}, credentials){
	  const parameter = credentials.parameter
	  delete credentials.parameter
	  const router = credentials.router
	  delete credentials.router
	  _executeApi(EP_QUICKO_LINK,parameter,credentials,'',commit, (error, result)=>{
		  if(!error){
			window.open(result.res_data,"_self")
		  }else{
			parameter.flashError(result.res_data, {timeout: msz_display_time});
		  }
	  })
	},
  	[RUN_USER_LOGIN]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.router
		delete credentials.router
		// parameter.disableloginBtn = true;
		_executeApi(EP_USER_LOGIN,parameter,credentials,'',commit, (error, result)=>{
			
			if(!error){
				// parameter.disableloginBtn = true;
				let path = ""
				let user_step = parseFloat(result.res_data.user.step)
				result.res_data.user.loggedIn = true
				if(result.res_data.user.hold_reason == -1 || result.res_data.user.hold_reason == ''){
					result.res_data.user.hold_reason = []
				}else{
					result.res_data.user.hold_reason = result.res_data.user.hold_reason.split(",")	
				}	
				commit(SET_STATE, result.res_data.user)
				
				const userInformation  = result.res_data

				var date1 = new Date(userInformation.user.password_changed_time);
				var date2 = new Date();
				var timeDiff = Math.abs(date2.getTime() - date1.getTime());
				var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 

				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
				if(parameter.signupOption) {
					parameter.webEngageUser()
				}
			
				if(user_step >= 8 && user_step < 10){
					// console.log('innn condition ')
					// window.gtag('event', 'Live_ac_verified', {'event_name': 'Live_ac_verified', 'send_to': 'G-R9YMKPBHC5'});
					window.fbq('track', 'complete registration');
				}

				if(user_step > 1 && user_step < 2){
					dispatch(types.RUN_SAVE_USERNAME_COMIG_FROM_PAN_API, {'page' : 'save_username_coming_from_pan', "rout":router,"parameter": parameter});
					path = '/Users/register/step1-5'
					router.replace(path); 
				}else if(user_step <= 6){
					dispatch(types.RUN_SAVE_USERNAME_COMIG_FROM_PAN_API, {'page' : 'save_username_coming_from_pan', "rout":router,"parameter": parameter});
					path = '/Users/register/step'+user_step
					router.replace(path); 
				}else if(user_step == 7){
					router.replace('/required/document/verification')
				}else if(user_step > 7){
					if(parseInt(result.res_data.user.account_status) == 2){
						router.push({ path: '/services/index/requestServiceElement', query: { ticket_type: 'EnableExchange' } })
					}else{
						router.replace('/Users/dashboard')
					}
				}
			}else{
				// parameter.disableloginBtn = false;
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	[RUN_USER_LOGIN_WITH_OTP]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.router
		delete credentials.router
		// parameter.disableloginBtn = true;
		_executeApi(EP_USER_LOGIN_WITH_OTP,parameter,credentials,'',commit, (error, result)=>{
			if(!error){
				// parameter.disableloginBtn = true;
				parameter.submitted = false
				parameter.step = 3
			}else{
				// parameter.disableloginBtn = false;
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
	[RUN_WEB_ENGAGE_USER]({commit, state, dispatch,getters}, credentials){
		return new Promise((resolve, reject) => {
			try {
				const parameter = credentials.parameter
				delete credentials.parameter
				const router = credentials.router
				delete credentials.router
				// parameter.disableloginBtn = true;
				_executeApi(EP_WEB_ENGAGE_USER,parameter,credentials,'',commit, (error, result)=>{
					if(!error){
						
						webengage.user.login(result.res_data[0].custom_id);
						let currentUser = getters['GET_USER'];

						if(parameter.webengageCheck) {
							if(!currentUser.FROM_KRA) {
								webengage.track("Non Kra User", {"Value": "Yes"});
                   				console.log("Non Kra User")
							}
						}
						if(currentUser.username) {

							const username = currentUser.username.split(' ');
							
							if(username[0]) {
	
								webengage.user.setAttribute('we_first_name', username[0]);
							}

							if(username.length > 1) {
								webengage.user.setAttribute('we_last_name', username[length - 1]);
							}

							webengage.user.setAttribute("FullName", currentUser.username);
						}
						webengage.user.setAttribute("we_email", result.res_data[0].email);
						webengage.user.setAttribute("we_phone", result.res_data[0].mobile_no);

						parameter.webEngageId = result.res_data[0].custom_id
						
					}else{
						// parameter.disableloginBtn = false;
						parameter.flashError(result.res_data, {timeout: msz_display_time});
					}
				})
		} catch (ex) {
		  reject(ex); // Reject the Promise with the caught error.
		}
	  });
		
	},
  	[RUN_USER_VERIFY_OTP]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.router
		delete credentials.router
		_executeApi(EP_USER_VERIFY_OTP,parameter,credentials,'',commit, (error, result)=>{
			if(!error){
				console.log('===action',result.res_data)
				let path = ""
				let user_step = parseFloat(result.res_data.user.step)

				result.res_data.user.loggedIn = true
				if(result.res_data.user.hold_reason == -1 || result.res_data.user.hold_reason == ''){
					result.res_data.user.hold_reason = []
				}else{
					result.res_data.user.hold_reason = result.res_data.user.hold_reason.split(",")	
				}	
				commit(SET_STATE, result.res_data.user)

				const userInformation  = result.res_data

				var date1 = new Date(userInformation.user.password_changed_time);
				var date2 = new Date();
				var timeDiff = Math.abs(date2.getTime() - date1.getTime());
				var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 

				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))

				if(parameter.signupOption) {

					parameter.webEngageUser();
				}
				
				if(user_step > 1 && user_step < 2){
					dispatch(types.RUN_SAVE_USERNAME_COMIG_FROM_PAN_API, {'page' : 'save_username_coming_from_pan', "rout":router,"parameter": parameter});
					path = '/Users/register/step1-5'
					router.replace(path); 
				}else if(user_step <= 6){
					dispatch(types.RUN_SAVE_USERNAME_COMIG_FROM_PAN_API, {'page' : 'save_username_coming_from_pan', "rout":router,"parameter": parameter});
					path = '/Users/register/step'+user_step
					router.replace(path); 
				}else if(user_step == 7){
					router.replace('/required/document/verification')
				}else if(user_step > 7){
					if(parseInt(result.res_data.user.account_status) == 2){
						router.push({ path: '/services/index/requestServiceElement', query: { ticket_type: 'EnableExchange' } })
					}else{
						router.replace('/Users/dashboard')
					}
				}
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
	[RUN_USER_VPA]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.router
		delete credentials.router
		_executeApi('/api/upi/notify/transstatus',parameter,credentials,'',commit, (error, result)=>{
			if(!error){
				parameter.resMsz = 'ok'
				parameter.status = result.res_data.Status 
				if(result.res_data.Status.toLowerCase() == 'pending'){
					setTimeout(() => {
						parameter.submit()
					}, 4000);
				}
			}else{
				parameter.resMsz = 'nok'
				parameter.status = ''
			}
		})
  	},
	[RUN_CHECK_BANK_LIST_AGGREGATOR]({commit, state, dispatch, getters}, credentials) {
		// getdata.parameter.pageLoader = true
		RxFactory.get(EP_CHECK_BANK_LIST_AGGREGATOR, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
		.map(response => response.data)
		.subscribe(data => {
				if(data.data && Array.isArray(data.data)){
					let tempBankList = [];
					data.data.map((value) => {
						tempBankList.push({
							key: value.fip_id,
							value: value.fip_name,
						})
					})
					commit(SET_BANK_AGGREGATOR_LIST, tempBankList);
				}
			},
		)
	},
	[RUN_USER_LOGOUT]({commit, state, getters}, getdata) {
		getdata.parameter.pageLoader = true
		RxFactory.get(BASE_URL + EP_ADMIN_LOGOUT, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
		.map(response => response.data)
		.subscribe(data => {
				getdata.parameter.pageLoader = false
				_handleLogout(data, commit, {router: getdata.router, forward:true})
			},
			(e, d, s) => {
				_handleLogout(e, commit, {router: getdata.router, forward:true})
			}
		)
	},
	[SET_API_DISCLAIMER]({commit, state,getters}, pid){	
		return new Promise((resolve, reject) => {
			try {
				RxFactory.post(BASE_URL + EP_SET_API_DISCLAIMER, {id: pid},{'Authorization': 'Bearer ' + getters.GET_TOKEN})
				.map(response => response.data)
				.subscribe(response => 
					{	
						if ('info' in response){
							if (response.info === 'OK' && response.data.affectedRows === 1) {
								let currentUser = getters['GET_USER'];
								currentUser['Disclaimer'] = 1;
								commit(SET_STATE, currentUser);
								resolve(true);
							}
							else{
								reject(false);
							}
						}
						else{
							reject(false);
						}
					},
				e => {	
					reject(false);
					_handleErrorResponse(e, commit)	
				}) 
				}catch(ex){	
					reject(false);
					_handleErrorResponse(ex, commit) 
				}
			});
	},
	[RUN_STATE_LOAD] ({commit, dispatch, state, getters},getdata) {
		const data = {}
		let user = localStorage.getItem('user')
		if (user) {
			user = atob(user) 
			user = JSON.parse(user)
		}
		if(getdata.page){	getdata.parameter.pageLoader = true  }
		if((user == null || user == '') && location.pathname == '/Users/dashboard'){ 
			window.location.href = "/"
		}else{
			commit(SET_STATE, user)
			RxFactory.post(BASE_URL + "/get/fresh/user/data",{},{'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							let path = ""
							data.data.user.loggedIn = true
							if(data.data.user.hold_reason == -1 || data.data.user.hold_reason == ''){
								data.data.user.hold_reason = []
							}else{
								data.data.user.hold_reason = data.data.user.hold_reason.split(",")	
							}
							commit(SET_STATE, data.data.user)
							localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))

							if(localStorage.getItem("digiLockerAttempt1") !=  undefined){
								if(localStorage.getItem("digiLockerAttempt1") == 'fail'){
									localStorage.removeItem("digiLockerAttempt1");
								
									getdata.router.replace({ name: "Users.UserRegisterStepMinusTwo",params:{msz:"There is some technical issue during fetching detail from digilocker, please wait and try again." } }) 
								}else if(localStorage.getItem("digiLockerAttempt1") == 'success'){
									localStorage.removeItem("digiLockerAttempt1");
									getdata.router.replace({ name: "Users.UserRegisterStepMinusTwo",params:{msz:"Fetch Information From digilocker successfully." } })
								}
								
							}								
							if(getdata.page){
								if(getdata.page == 'indexVue'){
									let message = "Thanks for registering with us, Your username and password are sent to your registered email." 
									if(parseInt(data.data.user.FROM_KRA) == 1){
										getdata.router.replace({ name: "Users.UserRegisterStepZero",params:{msz:message } })
									}else{
										getdata.router.replace({ name: "Users.UserRegisterStepMinusTwo",params:{msz:message } }) 
									}
									getdata.parameter.pageLoader = false
								}else if(getdata.page == 'step4Doc'){
									getdata.router.replace('/Users/register/step4');
									getdata.parameter.pageLoader = false
								}else if(getdata.page == 'ksoftPortfolio'){
									getdata.router.replace('/ManageAccounts/ksoft-portfolio');
									getdata.parameter.pageLoader = false
								}else if(getdata.page == 'raiseticket' || getdata.page == 'boreports' || getdata.page == 'refferal' || getdata.page == 'pledge'){
									getdata.router.replace(getdata.pageParameter);
									getdata.parameter.pageLoader = false
								}else if(getdata.page == 'document'){
									if(parseInt(data.data.user.step) > 3 && parseInt(data.data.user.step) < 7){
										getdata.router.replace('/Users/register/step'+data.data.user.step);
										getdata.parameter.pageLoader = false
									}else if(parseInt(data.data.user.step) == 7){
										getdata.router.replace('/required/document/verification')
										getdata.parameter.pageLoader = false
									}else if(parseInt(data.data.user.step) > 7){
										getdata.router.replace('/Users/dashboard');
										getdata.parameter.pageLoader = false
									}else{
										getdata.parameter.pageLoader = false
										getdata.parameter.getStepInfoFunc('old')
										getdata.parameter.DoSign()
									}
								}else if(getdata.page == 'nominee'){
									getdata.router.replace('/Users/register/step1-5');
									getdata.parameter.pageLoader = false
								}else if(getdata.page == 'afterDocumentDelete'){
									dispatch(types.RUN_GET_INFORMATION, {"step" : 4,"parameter": getdata.parameter,"rout" : getdata.router, "oldData" : "old"});
								}else if(getdata.page == 'step5Doc'){
									getdata.router.replace('/Users/register/step5');
									getdata.parameter.pageLoader = false
								}else if(getdata.page == 'document1'){
									if(parseInt(data.data.user.step) >= 4 && parseInt(data.data.user.step) <= 6){
										getdata.router.replace('/Users/register/step'+data.data.user.step);
										getdata.parameter.pageLoader = false
									}else if(parseInt(data.data.user.step) == 7){
										getdata.router.replace('/required/document/verification')
										getdata.parameter.pageLoader = false
									}else if(parseInt(data.data.user.step) > 7){
										getdata.router.replace('/Users/dashboard');
										getdata.parameter.pageLoader = false
									}else{
										getdata.parameter.pageLoader = false
									}
								}else if(getdata.page == 'token_demat_ticket'){
									getdata.router.replace('/Accounts/open-demat')
									getdata.parameter.pageLoader = false
								}else if(getdata.page == 'EnableExchange'){
									getdata.router.push({ path: '/services/index/requestServiceElement', query: { ticket_type: 'EnableExchange' } })
									getdata.parameter.pageLoader = false
								}     
							}else{
								if(parseInt(data.data.user.step) > 1 && parseInt(data.data.user.step) < 2){
									dispatch(types.RUN_SAVE_USERNAME_COMIG_FROM_PAN_API, {'page' : 'save_username_coming_from_pan', "rout":getdata.router,"parameter": parameter});
									path = '/Users/register/step1-5'
									getdata.router.replace(path); 
								}else if(parseInt(data.data.user.step) <= 6){
									dispatch(types.RUN_SAVE_USERNAME_COMIG_FROM_PAN_API, {'page' : 'save_username_coming_from_pan', "rout":getdata.router,"parameter": getdata.parameter});
									path = '/Users/register/step'+parseInt(data.data.user.step)
									getdata.router.replace(path); 
								}else if(parseInt(data.data.user.step) == 7){
									getdata.router.replace('/required/document/verification')
								 }
								 //else if(parseInt(data.data.user.step) > 7){
								// 	if(parseInt(data.data.account_status) == 2){
								// 		getdata.router.push({ path: '/services/index/requestServiceElement', query: { ticket_type: 'EnableExchange' } })
								// 	}else{
								// 		getdata.router.replace('/Users/dashboard')
								// 	}
								// }
							}
						}
					}
				},
				e => {					
					_handleErrorResponse(e, commit)
				}
			)
		}
	},
	[RUN_DELETE_DOCUMENT]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_DELETE_DOCUMENT,parameter,credentials,'',commit, (error, result)=>{
			if(!error){
				parameter.documentJsonData = {}
				if(credentials.doc_type == 'nominee'){
					dispatch(Const.RUN_GET_CLIENT_NOMINEE_DATA,{'page' : 'nominee', "router":rout,"parameter": parameter})
					parameter.nomineeAddJson[credentials.index].showimg = 0
					parameter.nomineeAddJson[credentials.index].identity_doc = {}
					parameter.nomineeAddJson[credentials.index].showotherimg = 0
					parameter.nomineeAddJson[credentials.index].identity_otherdoc = {}
				}else{
					if(credentials.doc_type == 'signature'){
						parameter.uploadSign = false
						setTimeout(() => {
		                    parameter.CreateCanvas()
		                }, 1000);
					}
					dispatch(types.RUN_STATE_LOAD, {'page' : 'afterDocumentDelete', "router":rout,"parameter": parameter});
				}
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	[RUN_SAVE_USERNAME_COMIG_FROM_PAN_API]({commit, state, dispatch,getters}, credentials){
		const type = credentials.type || ''
		delete credentials.type
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		// _executeApi(EP_SAVE_USERNAME_COMIG_FROM_PAN_API,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
		// 	if(!error){
		// 		if(type == 'verify_pan'){
					
		// 		}
		// 	}else{}
		// })
  	},
	[RUN_VERIFY_DOB]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_VERIFY_DOB,parameter,credentials,'',commit, (error, result)=>{
			
			if(!error){
				let path
				console.log('innn dob ')
				// window.gtag('event', 'PAN/DOB_Verify', {'event_name': 'PAN/DOB_Verify', 'send_to': 'G-R9YMKPBHC5'});
				
				result.res_data.user.loggedIn = true
				commit(SET_STATE, result.res_data.user)
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))

                webengage.track("Confirm Pan Card Success", {"Value": "Yes"});
				console.log("Confirm Pan Card Success")
				let check_kra = true

				parameter.webEngageUser(check_kra)
				
				let message = "Thanks for registering with us, Your username and password are sent to your registered email." 
				if(parseInt(result.res_data.user.FROM_KRA) == 1){
					rout.replace({ name: "Users.UserRegisterStepZero",params:{msz:message } })
				}else{
					rout.replace({ name: "Users.UserRegisterStepMinusTwo",params:{msz:message } }) 
					
				}
				parameter.javascriptFunc('verify_pan')
				dispatch(types.RUN_SAVE_USERNAME_COMIG_FROM_PAN_API, {'page' : 'save_username_coming_from_pan', "rout":rout,"parameter": parameter,'type' : 'verify_pan'});
				parameter.callPanTracking()
			}else{

				webengage.track("Confirm Pan Card Failed", {"Value": "Yes"});
				console.log("Confirm Pan Card Failed")
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	[RUN_STEP_SKIP_API]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_STEP_SKIP_API,parameter,credentials,'',commit, (error, result)=>{
			if(!error){
				//rout.replace('/Users/register/step5');
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
//====================================registeration steps======================================================	
	[RUN_CREATE_LEAD]({commit, state, dispatch,getters}, credentials){
		let encryptClientCode = (val) => {
            if (val) {
                try {
                    const key = CryptoJS.enc.Utf8.parse(process.env.VITE_CRYPTO_ENCRYPTION_KEY_LEAD);
                    const iv = CryptoJS.enc.Utf8.parse(process.env.VITE_CRYPTO_ENCRYPTION_IV_LEAD);
                    const encrypted = CryptoJS.AES.encrypt(val, key, {
                        iv: iv,
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7
                    });
                    return encrypted.toString();
                } catch (error) {
                    console.error('Decryption error:', error);
                    return null;
                }
            }
            return null;
        };
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.router
		delete credentials.router
		let encodedObject = encryptClientCode(JSON.stringify(credentials))
		_executeApi(EP_CREATE_LEAD,parameter,{data: encodedObject},'',commit, (error, result)=>{
			if(!error){
				// window.gtag('event', 'OTP_Gen_Lead', {'event_name': 'OTP_Gen_Lead', 'send_to': 'G-R9YMKPBHC5'});
				window.fbq('track', 'initiate checkout');
				// if(parameter.webengageCallback) { Register Login EaRlier
				// 	parameter.webEngageUser(true)
				// }
				if(parameter.webengageCallback) {

					webengage.user.setAttribute("we_email", parameter.email);
					webengage.user.setAttribute("we_phone", parameter.mobile);
					webengage.debug(true)
					// webengage.state.getForever()
					console.log("Get Started")
					webengage.track("Get Started", {"Value": "Yes"});
				}
				if(parameter.resendOTPCallback) {
					console.log("Resend OTP Success")
					webengage.track("Resend OTP Success", {"Value": "Yes"});
				}
				parameter.inserted_id = result.res_data.insertId
				parameter.utm_landing_page = result.res_data.utm_landing_page
				parameter.publisher_id = result.res_data.publisher_id
				parameter.adv_id = result.res_data.adv_id
				parameter.transaction_id = result.res_data.transaction_id
				parameter.clearCookieFunc()
				parameter.flashSuccess("We have sent an OTP on email and mobile number that you have provided!", {timeout: msz_display_time});
				
			}else{
				if(parameter.resendOTPCallback) {
					console.log("Resend OTP Failed")
					webengage.track("Resend OTP Failed", {"Value": "Yes"});
				}
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	[RUN_PAN_VERIFY]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_VERIFY_PAN,'',credentials,'',commit, (error, result)=>{
			if(!error){
				parameter.pan_var_verify = true
			}else{
				parameter.flashError("Please Enter Valid Pan", {timeout: msz_display_time});
				let msgg = result.res_data.toLowerCase();
				if(msgg == "invalid remote response"){
					parameter.pan_var_verify = true
				}else{
					parameter.pan_var_verify = false
				}
			}
		})
  	},
  	[RUN_VERIFY_LEAD_OTP]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const router = credentials.router
		delete credentials.router
		_executeApi(EP_VERIFY_OTP_LEAD,parameter,credentials,'',commit, (error, result)=>{
			if(!error){
				parameter.STEP = 2
				parameter.javascriptFunc('verify_otp')
				// window.gtag('event', 'OTP_verify', {'event_name': 'OTP_verify', 'send_to': 'G-R9YMKPBHC5'});
				// window.gtag('event', 'conversion', {'send_to': 'AW-975363956/nNhRCI6dgP8CEPS-i9ED'});
				window.rdt('track', 'Lead')
				window.qp('track', 'GenerateLead');
				window.fbq('track', 'lead');
				console.log("OTP Verified Sucess")
				webengage.track("OTP Verified Sucess", {"Value": "Yes"});
				webengage.user.setAttribute("we_email", parameter.email);
				webengage.user.setAttribute("we_phone", parameter.mobile);
				parameter.callOTPTracking()
			}else{
				console.log("OTP Verified Failed")
				webengage.track("OTP Verified Failed", {"Value": "Yes"});
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
	[RUN_GET_INFORMATION]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const rout = credentials.rout
			delete credentials.rout
			let oldData = '';
			if(parseInt(credentials.step) == 4 && credentials.oldData){
				
				oldData = credentials.oldData
				delete credentials.oldData
			}
			parameter.pageLoader = true
			let FROM_KRA = parseInt(getters['GET_USER'].FROM_KRA) 
			let db_step = parseInt(getters['GET_USER'].step) 
			//Check FOM KRA
			if(((parseInt(FROM_KRA) == 0 && parseInt(getters['GET_USER'].profile.entered_manually) == 0 && parseInt(db_step) >= -1) || (parseInt(FROM_KRA) == 1)) && (parseInt(credentials.step) == -1 || parseInt(credentials.step) == -2)){
				rout.replace('/Users/register/step0')	
			}
			
			
			if(parseInt(db_step) >  6){
				console.log('RUN_GET_INFORMATION')
				rout.replace('/Users/dashboard')
			}else{
				if((parseInt(credentials.step) <= parseInt(db_step)) || (parseInt(credentials.step) == parseInt(db_step)+1)){
					rout.replace('/Users/register/step'+ credentials.step)
				}else{
					console.log(db_step)
					rout.replace('/Users/register/step'+ db_step)
				}
			}
			/*else if(parseInt(user_step) >  6){
				rout.replace('/Users/dashboard')
			}else if(parseInt(user_step) <=  parseInt(credentials.step)){
				rout.replace('/Users/register/step'+ user_step)
			}else if(parseInt(user_step) === 6){
				rout.replace('/Users/register/step'+ user_step)
			}*/
			if(parseInt(credentials.step) == 5){
				parameter.pageLoader = false
				return ; 
			}
			RxFactory.post(BASE_URL + EP_RUN_GET_INFORMATION  ,credentials, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
			.map(response => response.data)
				.subscribe(data => {
					parameter.pageLoader = false
					if ('info' in data) {
						if (data.info === 'OK') {
							switch(credentials.step){
								case -2:
									if(Object.keys(data.data).length > 0){
										parameter.getInfoFromApi = data.data
										if(data.data.username !== '' || data.data.husband_name !== '' ||  data.data.residential_status !== '' || data.data.gender !== '' || data.data.martial_status !== '' || data.data.nationality !== ''){
											parameter.div_hide_show = 1
										}else{
											parameter.div_hide_show = 0
										}

										parameter.first_name		=	 __formatName(data.data.username)[0]
										parameter.middle_name		=	 __formatName(data.data.username)[1]
										parameter.last_name		    =	 __formatName(data.data.username)[2]
										parameter.father_spouse_name		=	 data.data.husband_name
										//parameter.resident        =     data.data.residential_status
										parameter.gender		=	 data.data.gender
										if(parseInt(getters['GET_USER'].FROM_KRA) == 1){
											parameter.martial_status 		=	 data.data.martial_status
										}
										
										parameter.nationality 		=	 data.data.nationality
									}else{
										parameter.getInfoFromApi = {}
									}
								break;
								case -1:
									if(Object.keys(data.data).length > 0){
										parameter.getInfoFromApi = data.data
										parameter.address1 	=  	 data.data.address1
					        			parameter.address2  =	 data.data.address2
					        			parameter.address3  =	 ( data.data.address3 != '' &&  data.data.address3 != null &&  data.data.address3 != undefined )? data.data.address3 : ''
					        			parameter.city      =	 data.data.city
					        			parameter.state     =	 data.data.state
					        			parameter.country   =	 data.data.country
					        			parameter.pincode   =	 data.data.pincode
					        			parameter.address_proof   =	 data.data.address_proof
					        			parameter.address_type   =	 data.data.address_type

					        			parameter.corr_address1 	=  	 data.data.corr_address1
					        			parameter.corr_address2  =	 data.data.corr_address2
					        			parameter.corr_address3  =	 ( data.data.corr_address3 != '' &&  data.data.corr_address3 != null &&  data.data.corr_address3 != undefined )? data.data.corr_address3 : '' 
					        			parameter.corr_city      =	 data.data.corr_city
					        			parameter.corr_state     =	 data.data.corr_state
					        			parameter.corr_country   =	 data.data.corr_country
					        			parameter.corr_pincode   =	 data.data.corr_pincode
					        			parameter.corr_address_proof  =  data.data.corr_address_proof
					        			parameter.adhar_no  =  data.data.adhar_no
					        			parameter.corr_aadhar_no  =  data.data.corr_aadhar_no

					        		}else{
										parameter.getInfoFromApi = {}
									}
								break;
								case 0:
									if(Object.keys(data.data).length > 0){
										let bank_list = getters[Const.GET_BANK_LIST]
										if(Object.keys(bank_list).indexOf(data.data.bank_name) == -1){
											parameter.bank_name 		=    	'Others'
											parameter.bank_name_other 	=    	data.data.bank_name
										}else{
											parameter.bank_name 		=    	data.data.bank_name
										}
										if(data.data.bank_account_no != '' && data.data.bank_ifsc != '' ){
											parameter.showContentScreen = '2'
											parameter.clearTimeInterval()     //means content screen visible
										}else{
											parameter.showContentScreen = '1'
										}
										parameter.account_number	=		data.data.bank_account_no
										parameter.ifsc_code			=		data.data.bank_ifsc
										parameter.bank_address		=		data.data.bank_address
										parameter.account_type		=		data.data.bank_accounttype
										parameter.micr_code			=		data.data.bank_micrcode 
									}else{
										parameter.showContentScreen = '1'
									}
								break;
								case 1:
									if(Object.keys(data.data).length > 0){
										parameter.stock_broker_check =      false
										parameter.mothername 		 =       data.data.mother_name
										parameter.maidenname		 =		data.data.maiden_name
									    parameter.income_check1		 =		data.data.gross_income
									    parameter.occupation_check1  =		data.data.occupation
									    parameter.occupation_other   =      data.data.occupation_other
										parameter.banktype			 =		data.data.trade_experience
										parameter.post_action		 =		data.data.past_actions
										parameter.post_action_area	 =		data.data.past_action_info
										parameter.dealing_name		 =		data.data.dealing_name
										parameter.dealing_ucc		 =		data.data.dealing_ucc
										parameter.dealing_ap		 =		data.data.dealing_ap
										parameter.dealing_dues		 =		data.data.dealing_dues
										parameter.pep		         =		data.data.pep
							            parameter.wealth_source		 =		data.data.wealth_source
										parameter.party_name		 =		data.data.party_name
										parameter.constituency		 =		data.data.constituency
										parameter.polictician_name	 =		data.data.polictician_name
										if(parseInt(getters['GET_USER'].FROM_KRA) == 0){
											parameter.martial_status 		=	 data.data.martial_status
											// parameter.address_type   =	 data.data.address_type
											// parameter.resident   =	 data.data.residential_status
											parameter.father_spouse_name   =	 data.data.husband_name
										}
										if(data.data.pep != ''){
											parameter.pep_check = 1
										}
										if(data.data.dealing_name != '' && data.data.dealing_ucc != '' && data.data.dealing_ap != '' && data.data.dealing_dues != ''){
											parameter.stock_broker_check =      true
										}
									}	
									
								break;
								case 2:
									if(Object.keys(data.data).length > 0){
										if(data.data.name_depository != '' && data.data.benificiary_bo_id != '' && data.data.dp_id != ''){
											parameter.demat_account_details = "exsisting_account"
											parameter.participant_name 	=    	data.data.participant_name
										}else{
											parameter.demat_account_details = "demat_account"
											parameter.demat_option = data.data.user_prefrence
											
										}
										
										parameter.name_depository	=		data.data.name_depository
										parameter.benificiary_bo_id	=		data.data.benificiary_bo_id
										parameter.dp_id				=		data.data.dp_id

										parameter.quartly_month     =       data.data.settlement == "M" ? 'monthly' : 'quarterly'

									}
								break;
								case 3:
									 if (Object.keys(data.data).length > 0) {
									    if (
									      parseInt(data.data.NSE_CASH) == 1 ||
									      parseInt(data.data.BSE_CASH) == 1
									    ) {
									      parameter.cash = true;
									      if (parameter.cash == true) {
									        localStorage.setItem("isCashSelected", true);
									      } else {
									        localStorage.setItem("isCashSelected", false);
									      }
									    } else {
									      parameter.cash = false;
									      parameter.NSE_BSE = false;
									    }
									    if (
									      parseInt(data.data.NSE_FO) == 1 ||
									      parseInt(data.data.BSE_FO) == 1
									    ) {
									      parameter.fo = true;
									    } else {
									      parameter.fo = false;
									      parameter.NSE_BSE = false;
									    }
									    if (
									      parseInt(data.data.NSE_CUR) == 1 ||
									      parseInt(data.data.BSE_CUR) == 1
									    ) {
									      parameter.currency = true;
									    } else {
									      parameter.currency = false;
									      parameter.NSE_BSE = false;
									    }
									    if (
									      parseInt(data.data.MCX) == 1 ||
									      parseInt(data.data.NCDEX) == 1
									    ) {
									      parameter.mcx_option = true;
									    } else {
									      parameter.mcx_option = false;
									    }
										if(parseInt(data.data.MCX) == 1){
											parameter.mcx = true;
										}
										else{
											parameter.mcx = false;
										}
										if(parseInt(data.data.NCDEX) == 1){
											parameter.ncdex = true;
										}
										else{
											parameter.ncdex = false;
										}
									    if (
									      data.data.fatca_country_birth != "" &&
									      (data.data.fatca_country_birth == "india" ||
									        data.data.fatca_country_birth == "India")
									    ) {
									      parameter.indian_tax_resident = 1;
									      parameter.fatca_bith_country =
									        data.data.fatca_country_birth;
									    }
									    parameter.fatca = data.data.fatca;

									    //parameter.fatca_bith_place					=  		data.data.fatca_birthplace
										parameter.fatca_birthplace = data.data.fatca_birthplace
										parameter.fatca_birth_country = data.data.fatca_country_birth
									    parameter.confirm = true;
									    parameter.fatca_identification_type =
									      data.data.identification_type;
									    parameter.fatca_country = data.data.fatca_country;
									    parameter.fatca_tin_number = data.data.fatca_tax_id;
									    if (
									      data.data.identification_type != "" &&
									      data.data.fatca_country != "" &&
									      data.data.fatca_tax_id != ""
									    ) {
									      parameter.tax_resident_other = 1;
									    }
									  }
									// if(Object.keys(data.data).length > 0){
									// 	if(parseInt(data.data.NSE_CASH) == 1 || parseInt(data.data.BSE_CASH) == 1){
									// 		parameter.cash =  true
									// 		if (parameter.cash == true) {
									// 			localStorage.setItem("isCashSelected", true);
									// 		} else {
									// 			localStorage.setItem("isCashSelected", false);
												
									// 		}
									// 	}
									// 	if(parseInt(data.data.NSE_FO) == 1 || parseInt(data.data.NSE_CUR) == 1  || parseInt(data.data.BSE_FO) == 1 || parseInt(data.data.BSE_CUR) == 1){
									// 		parameter.fo =  true
									// 	}
									// 	if(parseInt(data.data.MCX) == 1 ){

									// 		parameter.mcx_option =  true
									// 	}
									// 	if(parseInt(data.data.NCDEX) == 1){
									// 		parameter.ncdex_option =  true
									// 	}
									// 	if(data.data.fatca_country_birth != '' && (data.data.fatca_country_birth == 'india' || data.data.fatca_country_birth == 'India')){
									// 		parameter.indian_tax_resident =  1
									// 		parameter.fatca_bith_country				=  		data.data.fatca_country_birth
									// 	}
									// 	parameter.fatca				=		data.data.fatca
										
									// 	//parameter.fatca_bith_place					=  		data.data.fatca_birthplace
									// 	parameter.confirm			=		true
									// 	parameter.fatca_identification_type				=		data.data.identification_type
									// 	parameter.fatca_country				=  		data.data.fatca_country
									// 	parameter.fatca_tin_number					=  		data.data.fatca_tax_id
									// 	if(data.data.identification_type != '' && data.data.fatca_country != '' && data.data.fatca_tax_id != ''){
									// 		parameter.tax_resident_other =      1
									// 	}
									// }
								break;
								case 4:
								
									var user_json = getters['GET_USER']
									if(oldData == ''){
										if(parseInt(user_json.FROM_KRA) == 0){
											parameter.fileName ='pan'
											parameter.documentsByName = {
												0 : {name: 'pan', title : 'UPLOAD YOUR PAN ' , description : 'Upload a scanned copy of your PAN card.', data:[]},
												1 : {name : 'signature', title : 'Your signature is needed' , description : '', data:[]},
												2 : {name : 'address', title : 'Upload your address proof' , description : '', data:[]},
												3 : {name : 'ipv_document', title : 'Upload Your Latest Image' , description : '', data:[{'name': '', 'file': '', 'fileName': ''}]}
											}
											parameter.filesAlreadyHave = {'pan' : false , 'signature' : false, 'address' : false}
											if(parseInt(parameter.profile_lists[0].BSE_CASH) == 1 && parseInt(parameter.profile_lists[0].NSE_CASH) == 1 && parseInt(parameter.profile_lists[0].NSE_FO) == 0 && parseInt(parameter.profile_lists[0].BSE_FO) == 0 && parseInt(parameter.profile_lists[0].MCX) == 0 && parseInt(parameter.profile_lists[0].NCDEX) == 0 &&   parseInt(parameter.profile_lists[0].BSE_CUR) == 0 && parseInt(parameter.profile_lists[0].NSE_CUR) == 0 ){

											}else{
												parameter.documentsByName = {
													0 : {name: 'pan', title : 'UPLOAD YOUR PAN ' , description : 'Upload a scanned copy of your PAN card.', data:[]},
													1 : {name : 'signature', title : 'Your signature is needed' , description : '', data:[]},
													2 : {name : 'bank', title : 'Upload any one income proof from the below:' , description : "<div class='row m-0 justify-content-center'><div class='col-12 col-md-12 p-0'><p class='mb-left mtmOb value-text description text-left'><span class='bullSelect p-0 d-block mt-1' style='font-size:12px;'> <label>&bull; 6 months bank statement</label> <label>&bull; 3 months salary slips</label> <label>&bull; Latest ITR (Income Tax Return)</label> <label>&bull; DEMAT holding statement</label> <label>&bull; Net worth certificate</label> <label>&bull; Copy of form 16</label> </span></p></div></div>", data:[]},
													3 : {name : 'address', title : 'Upload your address proof' , description : '', data:[]},
													4 : {name : 'ipv_document', title : 'Upload Your Latest Image' , description : '', data:[{'name': '', 'file': '', 'fileName': ''}]}
												}
												parameter.filesAlreadyHave = {'pan' : false , 'signature' : false , 'address' : false}
											}

											if(parseInt(user_json.profile.entered_manually) == 1 && parseInt(parameter.profile_lists[0].address_proof) == 31){
												parameter.double_allow = ['address']
											}
										}else{
											parameter.fileName ='signature'
											if(parseInt(parameter.profile_lists[0].BSE_CASH) == 1 && parseInt(parameter.profile_lists[0].NSE_CASH) == 1 && parseInt(parameter.profile_lists[0].NSE_FO) == 0 && parseInt(parameter.profile_lists[0].BSE_FO) == 0 && parseInt(parameter.profile_lists[0].MCX) == 0 && parseInt(parameter.profile_lists[0].NCDEX) == 0   && parseInt(parameter.profile_lists[0].BSE_CUR) == 0 && parseInt(parameter.profile_lists[0].NSE_CUR) == 0){
												parameter.documentsByName = {
													0 : {name : 'signature', title : 'Your signature is needed' , description : '', data:[]},
													// 1 : {name : 'bank', title : 'Upload any one income proof from the below:' , description : "<div class='row m-0 justify-content-center'><div class='col-12 col-md-8'><p class='mb-left mtmOb value-text description text-left'><span class='bullSelect p-0 d-block mt-1' style='font-size:12px;'> <label>&bull; 6 months bank statement</label> <label>&bull; 3 months salary slips</label> <label>&bull; Latest ITR (Income Tax Return)</label> <label>&bull; DEMAT holding statement</label> <label>&bull; Net worth certificate</label> <label>&bull; Copy of form 16</label> </span></p></div></div>", data:[]},
													1 : {name : 'ipv_document', title : 'Upload Your Latest Image' , description : '', data:[{'name': '', 'file': '', 'fileName': ''}]}
												}
											}else{
												parameter.documentsByName = {
													0 : {name : 'signature', title : 'Your signature is needed' , description : '', data:[]},
													1 : {name : 'bank', title : 'Upload any one income proof from the below:' , description : "<div class='row m-0 justify-content-center'><div class='col-12 col-md-12 p-0'><p class='mb-left mtmOb value-text description text-left'><span class='bullSelect p-0 d-block mt-1' style='font-size:12px;'> <label>&bull; 6 months bank statement</label> <label>&bull; 3 months salary slips</label> <label>&bull; Latest ITR (Income Tax Return)</label> <label>&bull; DEMAT holding statement</label> <label>&bull; Net worth certificate</label> <label>&bull; Copy of form 16</label> </span></p></div></div>", data:[]},
													2 : {name : 'ipv_document', title : 'Upload Your Latest Image' , description : '', data:[{'name': '', 'file': '', 'fileName': ''}]}
												}
											}
											parameter.filesAlreadyHave = {'signature' : false }
										}
									}
									
									if((parseInt(parameter.profile_lists[0].MCX) == 1  || parseInt(parameter.profile_lists[0].NCDEX) == 1) && parseInt(parameter.profile_lists[0].NSE_CASH) == 0 && parseInt(parameter.profile_lists[0].BSE_CASH) == 0){
										parameter.tradingSegment = false
									}

									let i;
									let user_data = JSON.parse(window.atob(localStorage.getItem("user")));
									let docJson = {};
									if(data.data.length > 0){
										for(i=0 ; i<=data.data.length-1 ; i++){
											data.data[i].ext = data.data[i].document.split('.')[1]

											if(data.data[i].doc_name != '' && data.data[i].doc_name != null){
												if(data.data[i].doc_name.includes(" ")){
								                    
								                    if(!docJson.hasOwnProperty(data.data[i].doc_name.split(' ')[0])){
								                    	docJson[data.data[i].doc_name.split(' ')[0]] = []
								                    	docJson[data.data[i].doc_name.split(' ')[0]].push(data.data[i]) 
								                    }else{
								                    	docJson[data.data[i].doc_name.split(' ')[0]].push(data.data[i])
								                    }
								                    
								                }else{
								                	docJson[data.data[i].doc_name] = []
													docJson[data.data[i].doc_name].push(data.data[i])
								                }
											}
											


											
											if(parameter.filesAlreadyHave.hasOwnProperty(data.data[i].doc_name)){
												parameter.filesAlreadyHave[data.data[i].doc_name] = true
											}else{
												parameter.filesAlreadyHave[data.data[i].doc_name] = false
											}
										}
										if(i == data.data.length){
											parameter.documentJsonData 	=   docJson
											if(parseInt(user_json.profile.entered_manually) == 1 && parseInt(parameter.profile_lists[0].address_proof) == 31){
												parameter.double_allow = ['address']
											}

											if(!docJson.hasOwnProperty('address') && parseInt(user_json.profile.entered_manually) == 0 && parseInt(user_json.FROM_KRA) == 0 && parseInt(parameter.profile_lists[0].address_proof) == 31){
												parameter.double_allow = ['address']
											}else if(docJson.hasOwnProperty('address') && docJson['address'].length > 1 && parseInt(user_json.profile.entered_manually) == 0 && parseInt(user_json.FROM_KRA) == 0 && parseInt(parameter.profile_lists[0].address_proof) == 31){
												parameter.double_allow = ['address']
											}
											if(user_data.profile.passport_image != '' && user_data.profile.passport_image != null){
												parameter.documentJsonData['ipv_document'] = []
												parameter.documentJsonData['ipv_document'].push({'document' : user_data.profile.passport_image})
												
											}
										}
									}else{
										
										 //user_json = getters['GET_USER']
										 // console.log('===================ssss=',user_json)
										// console.log('in user_json error= in nhi chlta==================',user_json.profile)
										parameter.documentJsonData = {}
										if(user_data.profile.passport_image != '' && user_data.profile.passport_image != null){
											parameter.documentJsonData['ipv_document'] = []
											parameter.documentJsonData['ipv_document'].push({'document' : user_data.profile.passport_image})
											
										}
										if(parseInt(user_json.profile.entered_manually) == 1 && parseInt(parameter.profile_lists[0].address_proof) == 31){
											parameter.double_allow = ['address']
										}
										if(parseInt(user_json.profile.entered_manually) == 0 && parseInt(user_json.FROM_KRA) == 0 && parseInt(parameter.profile_lists[0].address_proof) == 31){
											parameter.double_allow = ['address']
										}
										
										
										if(parseInt(user_json.FROM_KRA) == 0){
											parameter.filesAlreadyHave = {'pan' : false , 'signature' : false, 'address' : false}
											if(parseInt(user_json.profile.entered_manually) == 1){
												parameter.filesAlreadyHave = {'pan' : false , 'signature' : false }
											}
										}else{
											parameter.filesAlreadyHave = {'signature' : false }
										}
									}
								break;
								case 6:
									var user_json = getters['GET_USER']
									if(parseInt(user_json.FROM_KRA) == 0 && parseInt(user_json.profile.entered_manually) == 1){
										parameter.errMsz = true
									}else{
										parameter.kycFunctionCall()
									}
								break;
							}
						}
						else{}
					}
				},
				e => {
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			_handleErrorResponse(ex, commit)
		}
	},
	[RUN_REGISTER_INITIAL_STEP1]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_ADD_REGISTER_DATA_STEP,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				changeStep(credentials.step,commit,getters)
				if(parameter.personalInformationCallback) {

					webengage.track("Personal Information Success", {"Value": "Yes"});
					console.log("Personal Information Success")
				}
				rout.replace('/Users/register/step-1');
			}else{
				if(parameter.personalInformationCallback) {

					webengage.track("Personal Information Failed", {"Value": "Yes"});
					console.log("Personal Information Failed")
				}
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
  	[RUN_KRA_USER_KYC]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		parameter.pageLoader = true
		let user_json = getters['GET_USER'], apiLink = '';
		
		if(parseInt(user_json.FROM_KRA) == 1){
			apiLink = EP_KRA_USER_KYC
		}else{
			apiLink = EP_KRA_USER_KYC_NON_KRA 
		}
		console.log('before running==========================')
		_executeApi(apiLink,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			console.log('after running==========================')
			if(!error){
				changeStep(7,commit,getters)
				rout.replace('/required/document/verification')	 
			}else{
				parameter.errMsz = true
			}
		})
  	},
  	[RUN_REGISTER_INITIAL_STEP2]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_ADD_REGISTER_DATA_STEP,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				changeStep(credentials.step,commit,getters)
				if(parameter.addressDetailsCallback) {
					webengage.track("Address Details Success", {"Value": "Yes"});
                    console.log("Address Details Success")
				}
				rout.replace('/Users/register/step0');
			}else{
				if(parameter.addressDetailsCallback) {
					webengage.track("Address Details Failed", {"Value": "Yes"});
                    console.log("Address Details Failed")
				}
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},


  	[RUN_ADD_STEP_AFTER_UPLOAD_PROFILE_IMAGE]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_ADD_STEP_AFTER_UPLOAD_PROFILE_IMAGE,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				changeStep(credentials.step,commit,getters)
				rout.replace('/Users/register/step5');
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
	[RUN_ADD_REGISTER_DATA_STEP0]({commit, state, dispatch,getters}, credentials){
		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_ADD_REGISTER_DATA_STEP0,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				changeStep(credentials.step,commit,getters)
				console.log(parameter)
				webengage.track("Bank Account Addition Success", {"Bank Name": `${parameter.bank_name}`});
				console.log('Bank Account Addition Success')
				rout.replace('/Users/register/step1');
			}else{
				webengage.track("Bank Account Addition Failed", {"Value": "Yes"});
				console.log('Bank Account Addition Failed')
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
	[RUN_ADD_REGISTER_DATA_STEP1]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_ADD_REGISTER_DATA_STEP,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				changeStep(credentials.step,commit,getters)
				//rout.replace('/Users/register/step2');
				rout.replace('/Users/register/step1-5');
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
  	[RUN_ADD_REGISTER_DATA_STEP1_5]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_ADD_COMPLAINT_DATA,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//changeStep(credentials.step,commit,getters)
				changeStep(1.5,commit,getters)
				rout.replace('/Users/register/step2');
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
  	[RUN_NO_ADD_NOMINEE]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_NO_ADD_NOMINEE,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				//changeStep(credentials.step,commit,getters)
				changeStep(1.5,commit,getters)
				rout.replace('/Users/register/step2');
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
	[RUN_ADD_REGISTER_DATA_STEP2]({commit, state, dispatch,getters}, credentials){ // api to add params
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		const demat_account_details = credentials.demat_account_details
		delete credentials.demat_account_details
		_executeApi(EP_ADD_REGISTER_DATA_STEP,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				changeStep(credentials.step,commit,getters)
				rout.replace({ name: "Users.UserRegisterStepThree",params:{demat_option:demat_account_details}})
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
	[RUN_ADD_REGISTER_DATA_STEP3]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_ADD_REGISTER_DATA_STEP,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				changeStep(credentials.step,commit,getters)
				rout.replace('/Users/register/step4');
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
	[RUN_ADD_REGISTER_DATA_STEP4]({commit, state, dispatch,getters}, credentials){
		let docType = '';
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout

		if(credentials.docType != undefined){
			docType = credentials.docType
			delete credentials.docType
		}

		_executeApi(EP_ADD_REGISTER_DATA_STEP4,parameter,credentials.form,{'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				if(docType == 'pan' && localStorage.getItem("digiLockerAttempt") != '' && localStorage.getItem("digiLockerAttempt") != null  && localStorage.getItem("digiLockerAttempt") != undefined){
					localStorage.removeItem("digiLockerAttempt");
				}
				changeStep(4,commit,getters)
				parameter.documentJsonData = {}
				parameter.getStepInfoFunc('old')
				parameter.clearOld()
				
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		}) 
  	},
	[FETCH_DIGIO_ESIGN_ID]({commit, state, dispatch,getters}, data){
		let inputJSON = data;
		inputJSON['source'] = '';
		return new Promise((resolve, reject) => {
			try {
				RxFactory.post(BASE_URL + EP_FETCH_DIGIO_ESIGN_ID, inputJSON)
					.map(response => response.data)
					.subscribe(data => {
						if ('info' in data) {
							if (data.info === 'OK') {
								let responseData = data.data;
								resolve(responseData);
							}
							else{
								reject(false)
							}
						}
				})
			}
			catch(error) {
				reject(false)
			}
		  });
  	},
	[RUN_SUBMIT_DIGIO_ESIGN_DOCUMENT]({commit, state, dispatch,getters}, data){
		return new Promise((resolve, reject) => {
			try {
				RxFactory.post(BASE_URL + EP_RUN_SUBMIT_ESIGN_DOCUMENT, data)
					.map(response => response.data)
					.subscribe(data => {
						if ('info' in data) {
							if (data.info === 'OK' && typeof data.data === 'string') {
								let responseData = data.data;
								resolve(responseData);
							}
							else{
								reject(false)
							}
						}
				})
			}
			catch(error) {
				reject(false)
			}
		  });
  	},
	[RUN_GET_REGISTER_STEP5]({commit, state, dispatch,getters}, credentials){
  		let step = '' ; 
		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		step = credentials.step
		delete credentials.step
		
		_executeApi(EP_GET_REGISTER_DATA_STEP5,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				parameter.profile_lists = result.res_data.result
				
				parameter.bankData = result.res_data
				if(step != undefined && step != '' && step != null){
					if (
					    parseInt(result.res_data.result[0].BSE_CASH) == 1 ||
					    parseInt(result.res_data.result[0].NSE_CASH) == 1
				  	) {
					    parameter.cash = true;
				  	}
				  	if (
					    parseInt(result.res_data.result[0].BSE_FO) == 1 ||
					    parseInt(result.res_data.result[0].NSE_FO) == 1
				  	) {
					    parameter.fo = true;
				  	}

				  	if (
					    parseInt(result.res_data.result[0].MCX) == 1 ||
					    parseInt(result.res_data.result[0].NCDEX) == 1
				  	) {
					    parameter.mcx_option = true;
				  	}

					if(parseInt(result.res_data.result[0].MCX) == 1){
						parameter.mcx = true;
					}
					if(parseInt(result.res_data.result[0].NCDEX) == 1){
						parameter.ncdex = true;
					}

				  	if (
					    parseInt(result.res_data.result[0].NSE_CUR) == 1 ||
					    parseInt(result.res_data.result[0].BSE_CUR) == 1
				  	) {
					    parameter.currency = true;
				  	}


					// if(parseInt(result.res_data.result[0].BSE_CASH) == 1 || parseInt(result.res_data.result[0].NSE_CASH) == 1){
					// 	parameter.cash = true  
					// }

					// if(parseInt(result.res_data.result[0].BSE_CUR) == 1 || parseInt(result.res_data.result[0].BSE_FO) == 1  || parseInt(result.res_data.result[0].NSE_CUR) == 1 || parseInt(result.res_data.result[0].NSE_FO) == 1){
					// 	parameter.fo = true  
					// }
					// if(parseInt(result.res_data.result[0].MCX) == 1){
					// 	parameter.mcx = true
					// }

					// if(parseInt(result.res_data.result[0].NCDEX) == 1){
					// 	parameter.ncdex = true
					// }
				}else{
					parameter.getStepInfoFunc('')
					//dispatch(types.RUN_GET_INFORMATION, {"step" : 4,"parameter": parameter,"rout" : rout});
				}
				
				
				if(result.res_data.result == undefined || result.res_data.result[0].user.pan_username == null ||  result.res_data.result[0].user.pan_username == '' || result.res_data.result[0].user.pan_username == ' ' || result.res_data.result[0].user.pan_username == undefined ){
					dispatch(types.RUN_SAVE_USERNAME_COMIG_FROM_PAN_API, {'page' : 'save_username_coming_from_pan', "rout":rout,"parameter": parameter});
				}
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
	},
	[RUN_ADD_REGISTER_STEP5]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_ADD_REGISTER_DATA_STEP,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				console.log(result)
				rout.replace('/Users/register/step6');
				changeStep(credentials.step,commit,getters)
				// rout.replace('/Users/register/step6').catch(()=>{console.log('step6 error');});
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	[RUN_SAVE_USER_QUESTION_ANS]({commit, state, getters}, credentials){
  		const routerTmp = credentials.router
		delete credentials.router
		_executeApi(EP_RUN_SAVE_USER_QUESTION,'',credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				routerTmp.replace("/Users/dashboard")
			}else{
				parameter.flashError("Something went wrong please try again", {timeout: msz_display_time});
			}
		})
  	},
  	
  	[RUN_ADD_REGISTER_DATA_STEP_UPLOAD_DOCS]({commit, state, dispatch,getters}, credentials){
  		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		parameter.pageLoader = true
		_executeApi(EP_ADD_REGISTER_DATA_STEP4,parameter,credentials.form,{'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			parameter.pageLoader = false
			if(!error){
				changeStep(6,commit,getters)
				let user_json = getters['GET_USER']
				user_json.profile.entered_manually = 0
				commit(SET_STATE, user_json)
				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.profile.entered_manually = 0
				console.log(user)									
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				rout.replace('/Users/register/step6');
				// if(parameter.mobileScreen == false){
				// 	parameter.mobileScreenMsz = '0'
				// 	changeStep(6,commit,getters)
				// 	rout.replace('/Users/register/step6');
				// }else{
				// 	parameter.mobileScreenMsz = '1'
				// }
				
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	
  	[RUN_GET_INFORMATION_FROM_DIGILOCKER]({commit, state, dispatch,getters}, credentials){
		const parameter = credentials.parameter
		delete credentials.parameter
		const rout = credentials.rout
		delete credentials.rout
		_executeApi(EP_GET_INFORMATION_FROM_DIGILOCKER,parameter,credentials,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				parameter.refreshData()
				parameter.digilocker_info = true
			}else{
				parameter.div_hide_show = 1
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	[RUN_GET_QUESTION_ANSWER] ({commit, state, getters}, data){
  		_executeApi(EP_RUN_GET_QUESTION,'',data,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				commit(SET_QUESTIONS, result.res_data)
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},
  	[RUN_VERIFY_OTP] ({commit, state, getters}, verifyData) {
		_executeApi(EP_USERVERIFYOTP,'',verifyData,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				const user_data 				= getters['GET_USER']
				user_data.profile.verified 		= 1
				const data_of_user = {user: user_data}
				commit(SET_STATE, data_of_user)
				commit(SET_STATE_PERSIST_LOCAL)
			}else{
				parameter.flashError(result.res_data, {timeout: msz_display_time});
			}
		})
  	},

	[RUN_VERIFY_QUEST_ANS] ({commit, state, getters}, questAnsData) {
		const routerTmp = questAnsData.router
		delete questAnsData.router
		const parameter = questAnsData.modal_show
		delete questAnsData.modal_show
		_executeApi(EP_RUN_VERIFY_USER_QUESTION,parameter,questAnsData,{'Authorization': 'Bearer ' + getters.GET_TOKEN},commit, (error, result)=>{
			if(!error){
				routerTmp.replace("/Users/dashboard")
			}else{
				parameter.loading = 0
				parameter.flashError("Your answer is incorrect", {timeout: msz_display_time});
			}
		})
	},

	[RUN_CHANGE_PASSWORD]({commit, state, getters}, credentials){
  		try {

  			const parameter = credentials.parameter
  			parameter.loading = 1
  			delete credentials.parameter
			
			const _that = this;
			parameter.pageLoader = true
  			RxFactory.post(BASE_URL + EP_RUN_CHANGE_PASSWORD, credentials, {
		      'Authorization': 'Bearer ' + getters[GET_TOKEN]
		    })
				.map(response => response.data)
				.subscribe(data => {parameter.pageLoader = false
					if ('info' in data) {
						parameter.loading = 0
						if (data.info === 'OK') {
							
							if(credentials.page == 'changepassword'){
								parameter.password = ''
								parameter.newpassword = ''
								parameter.cpassword = ''
								parameter.flashSuccess("Successfully changed password", {timeout: msz_display_time});
								
							}else{

								//console.log(getters['GET_USER'])
								data = getters['GET_USER']


							
								if(parseInt(data.profile.use2fa) == 0){
									parameter.modal_show = 2
								}else{
									parameter.modal_show = 1
								}
							}
						    
							
						}else{
							if(credentials.page == 'changepassword'){
								parameter.flashError(data.msg, {timeout: msz_display_time});
							}
						}
						
					}
				},
				e => {
					//console.log("In e", e)
					// commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			//console.log("In e", ex)
			// commit(Const.SET_LOADER_STATUS, 0)
			_handleErrorResponse(ex, commit)
		}
  	},

	[RUN_CHANGE_PASSWORD_FORGOT]({commit, state, getters}, credentials){
  		try {

  			const parameter = credentials.parameter
  			parameter.loading = 1
  			delete credentials.parameter
			//parameter.$parent.pageLoader = true
			const _that = this;
  			RxFactory.post(BASE_URL + EP_RUN_CHANGE_PASSWORD_FORGOT, credentials)
				.map(response => response.data)
				.subscribe(data => {//parameter.$parent.pageLoader = false
					if ('info' in data) {
						parameter.loading = 0
						if (data.info === 'OK') {
							
							parameter.password = ''
							parameter.cpassword = ''
							parameter.flashSuccess("Password Reset Successfully. Please login again", {timeout: msz_display_time});
							window.location.href = "/"
						    
							
						}else{
							parameter.flashError(data.msg, {timeout: msz_display_time});
							//Swal("Error!", data.msg, "error")
						    
						}
						
					}
				},
				e => {
					//console.log("In e", e)
					// commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			//console.log("In e", ex)
			// commit(Const.SET_LOADER_STATUS, 0)
			_handleErrorResponse(ex, commit)
		}
  	},
  	
  	[RUN_CHANGE_FORGOT_PASSWORD]({commit, state, getters}, credentials){
  		try {

  			const parameter = credentials.parameter
  			parameter.loading = 1
  			delete credentials.parameter
			parameter.pageLoader = true
			const _that = this;
  			RxFactory.post(BASE_URL + EP_RUN_SEND_FORGOT_PASSWORD_EMAIL, credentials)
				.map(response => response.data)
				.subscribe(data => {parameter.pageLoader = false
					if ('info' in data) {
						parameter.loading = 0
						if (data.info === 'OK') {
							
							parameter.password = ''
							parameter.cpassword = ''
							parameter.flashSuccess("Password reset request sent successfully, please check your email.", {timeout: msz_display_time});
							//Swal("Success!", "Please check you email", "success")			    
							
						}else{
							parameter.flashError("PAN not found!", {timeout: msz_display_time});
							//Swal("Error!", "Client code Not found!", "error")
							
						}
						
					}
				},
				e => {
					//console.log("In e", e)
					// commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			//console.log("In e", ex)
			// commit(Const.SET_LOADER_STATUS, 0)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[RUN_UNBLOCK_USER_HASH]({commit, state, getters}, credentials){
  		try {

  			const parameter = credentials.parameter
  			parameter.loading = 1
  			delete credentials.parameter
			
			const _that = this;
  			RxFactory.post(BASE_URL + EP_RUN_UNBLOCK_HASH, credentials)
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						parameter.loading = 0
						if (data.info === 'OK') {
							
							parameter.hideEmailLink = 1
							
							// Swal("Success!", "A unblock link has been sent on your email. Please check you email", "success")
						}else{
							parameter.flashError("Client Code Not found. Please connect to our support!", {timeout: msz_display_time});
							//Swal("Error!", "Client Code Not found. Please connect to our support!", "error")
							
						}
						
					}
				},
				e => {
					//console.log("In e", e)
					// commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			//console.log("In e", ex)
			// commit(Const.SET_LOADER_STATUS, 0)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[RUN_BLOCK_USER]({commit, state, getters}, credentials){
  		try {

  			const parameter = credentials.parameter
  			parameter.loading = 1
  			delete credentials.parameter
			
			const _that = this;
  			RxFactory.post(BASE_URL + EP_RUN_BLOCK_USER, credentials)
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						parameter.loading = 0
						if (data.info === 'OK') {
							
							localStorage.setItem('blocked_user_name', parameter.email)
							parameter.msgInfo = "You're blocked due to more than 3 wrong login attempts"
							parameter.loginScreen = false
							// Swal("Success!", "Oops! You're blocked due to more than 3 wrong login attempts", "success")

							parameter.blocked_counter = 0
						}else{
							
							parameter.loginScreen = true
							// Swal("Errot!", "Email Not found!", "error")
							
						}
						
					}
				},
				e => {
					//console.log("In e", e)
					// commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			//console.log("In e", ex)
			// commit(Const.SET_LOADER_STATUS, 0)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[RUN_UNBLOCK_USER]({commit, state, getters}, credentials){
  		try {

  			const parameter = credentials.parameter
  			parameter.loading = 1
  			delete credentials.parameter
			
			const _that = this;
  			RxFactory.post(BASE_URL + EP_RUN_UNBLOCK_USER, credentials)
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						parameter.loading = 0
						if (data.info === 'OK') {
							//parameter.flashSuccess("You can now login to your account.", {timeout: msz_display_time});
							Swal.fire({
	                          title: 'Successfully Unblocked',
	                          text: 'You can now login to your account.',
	                          type: 'success',
	                          showCancelButton: false,
	                          confirmButtonText: 'Back to Login Page'
                    		}).then((result) => {
                    			window.location.href = "/"
                    		})

							// window.location.href = "/"

							

						}else{
							parameter.flashError("Something went wrong.", {timeout: msz_display_time});
							//Swal("Error!", "Something went wrong.", "error")
							// Swal("Errot!", "Email Not found!", "error")
							
						}
						
					}
				},
				e => {
					//console.log("In e", e)
					// commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			//console.log("In e", ex)
			// commit(Const.SET_LOADER_STATUS, 0)
			_handleErrorResponse(ex, commit)
		}
  	},
	[RUN_HDFC_TRANSACTIONS]({ commit, state, getters }, credentials) {

		return new Promise((resolve, reject) => {
			try {
				const parameter = credentials.parameter
				delete credentials.parameter
				const rout = credentials.rout
				delete credentials.rout
					
				RxFactory.post(process.env.BANK_STAGING + EP_HDFC_TRANSACTIONS, credentials)
						.map(response => response.data)
						.subscribe(data =>  {	
							if ('info' in data){
								
								if (data.info === 'OK' && data.data) { 
				
									const response = data.data;
									if(response.length) {
										parameter.transaction_list = response;
										resolve(response);
									} else {
										reject(false);
										parameter.transaction_list = [];
									}
								}
								else{
									reject(false);
									parameter.flashError("Something went wrong.", {timeout: msz_display_time});
								}
							}
							
						},
					e => {	
						reject(false)
						_handleErrorResponse(e, commit)	
					}) 
			}
			catch(error) {
				reject(false)
			}
		  });
			
	},
	[RUN_HDFC_VALIDATE_TRANSACTION]({ commit, state, getters }, credentials) {

		return new Promise((resolve, reject) => {
			try {
				const parameter = credentials.parameter
				delete credentials.parameter
				const rout = credentials.rout
				delete credentials.rout
					
				RxFactory.post(process.env.BANK_STAGING + EP_HDFC_VALIDATE_TRANSACTION, credentials)
						.map(response => response.data)
						.subscribe(data =>  {	
							if ('info' in data){
								
								if (data.info === 'OK' && data.data) { 
				
									const response = data.data;
									if(response.length) {
										parameter.flashSuccess("Transaction Verified.", {timeout: msz_display_time});
										resolve(response);
									} else {
										reject(false);
										
									}
								}
								else{
									reject(false);
									parameter.flashError(" Due to some technical issues, Please try again after some time.", {timeout: msz_display_time});
								}
							}
							
						},
					e => {	
						reject(false)
						_handleErrorResponse(e, commit)	
					}) 
			}
			catch(error) {
				reject(false)
			}
		  });
			
	},
}
//--------------------------------functions--------------------------------------
function changeStep(step,commit,getters){
	console.log('step', step)
	let user_json = getters['GET_USER']
	user_json.step = step
	commit(SET_STATE, user_json)
	var user = localStorage.getItem('user')
	user = atob(user)	;	user = JSON.parse(user)
	user.step = step									
	localStorage.setItem('user', btoa(JSON.stringify(user)))
}
function _executeApi(apiLink,parameter,credentials, getToken, commit, callback) {
    try {
        let response_array = [], pageName = '' ;
        if (credentials.form) { 
        	credentials = credentials.form 
        }else if(credentials.page && credentials.page == 'save_username_coming_from_pan'){
        	pageName = credentials.page
        	delete credentials.page
        }
        if (getToken == '') { getToken = '' }

        if(pageName == ''){
        	parameter.pageLoader = true 
        }else{
        	parameter.pageLoader = false
        }
        
        RxFactory.post(BASE_URL + apiLink, credentials, getToken)
            .map(response => response.data)
            .subscribe(data => {
                parameter.pageLoader = false
					if ('info' in data) {
                        if (data.info === 'OK') {
							response_array.res_data = data.data
							callback(false, response_array)
						}else{
							response_array.res_data = data.msg
							callback(true, response_array)
						}
                    }
                },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}
function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  commit(SET_TOGGLE_LOADER, loaderArr)
  commit(SET_INFO, msg)
}
function _handleErrorResponse (e, commit) {
    let response = {info: 'NOK', msg: 'Service not available'}
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
			response = {info: 'NOK', msg: 'Network Error'}
			}
		} catch(e){}
	}else{
		if(e.response.status == '401'){
			let user = {
				active: 0,
				country: '',
				created: '',
				email: '',
				profile: {
					firstname: '',
					lastname: '',
					pid: '',
					cid: ''
				},
				roles: '',
				token: false,
				username: '',
				loggedIn: false
			}
			commit(SET_STATE, user)
			localStorage.setItem('user', '')
			window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}
function _handleLogout (data, commit,options,getters) {
	const router = options.router
	let user = {}
	localStorage.removeItem("user");
	localStorage.removeItem("margin_info");
	webengage.user.logout();
	commit(SET_STATE, user)
	commit(SET_STATE_PERSIST_LOCAL)
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.replace('/')
	}
}
function  __formatName(userName){
	let finalName = []
      if(userName != null && userName != ""){
        userName = userName.split(" ")
        if(typeof userName[0] !== 'undefined') {
          finalName[0] = userName[0]
        } else {
          finalName[0] = ""
        }

        if(typeof userName[1] !== 'undefined') {
          finalName[1] = userName[1]
        } else {
          finalName[1] = ""
        }

        if(typeof userName[2] !== 'undefined') {
          finalName[2] = userName[2]
        } else {
          if(typeof userName[1] !== 'undefined') {
            finalName[2] = userName[1]
            finalName[1] = ""
          } else {
            finalName[2] = ""
          }
        }
        return finalName;
      } else {
        finalName[0] = ""
        finalName[1] = ""
        finalName[2] = ""
        return finalName;
      }
}




// WEBPACK FOOTER //
// ./src/store/actions.js